import React, { Component } from "react";
import { ReduxConnect, Router } from "../../../../toolkit/decorators/Artifact";
import { Helmet } from "react-helmet";
import SnapshotComponent from "../../../components/comisionesMembresia/snapshot/Snapshot";
import { SnapshotStore, snapshotStore } from "./Snapshot.store";
import { SnapshotDispatcher, snapshotDispatcher } from "./Snapshot.dispatcher";
import Layout from "../../../components/layout";

interface Props extends SnapshotStore, SnapshotDispatcher {}
interface State {}

@Router()
@ReduxConnect(snapshotStore, snapshotDispatcher)
export default class SnapshotContainer extends Component<Props, State> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Gestión de incidencias - Membresías" />
          <SnapshotComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
